import axios from 'axios';
import { setInitialTab } from '../local_storage';
import { changeRecords } from './search';
import { disableAutoBoundsSearching } from './coordinates';
import { propertyFromApi } from '../../../property_api';

export const HIDE_MAP_INFO_BUBBLE = 'HIDE_MAP_INFO_BUBBLE';
export function hideMapInfoBubble() {
  return { type: HIDE_MAP_INFO_BUBBLE };
}

export const SHOW_MAP_INFO_BUBBLE = 'SHOW_MAP_INFO_BUBBLE';
export function showMapInfoBubble(property) {
  return { property, type: SHOW_MAP_INFO_BUBBLE };
}

export function selectPropertyMarker(propertyId) {
  return (dispatch, getState) => {
    const properties = getState().search.properties;
    let property = properties.find(property => property.id === propertyId);

    // Showing the info bubble may or may not change the bounds - don't research either way
    dispatch(disableAutoBoundsSearching());

    if (property == null) {
      dispatch(showMapInfoBubble(null));
      return axios.get(`/research/properties/${propertyId}.json`).then((response) => {
        property = propertyFromApi(response.data.property);
        const meta = getState().search.meta;
        dispatch(changeRecords([...properties, property], meta));
        dispatch(showMapInfoBubble(property));
      });
    } else {
      dispatch(showMapInfoBubble(property));
    }
  };
}

export const SWITCH_TAB = 'SWITCH_TAB';
export function switchTab(tab) {
  setInitialTab(tab);
  return { tab, type: SWITCH_TAB };
}

export const TOGGLE_FILTERS = 'TOGGLE_FILTERS';
export function toggleFilters() {
  return { type: TOGGLE_FILTERS };
}

export const TOGGLE_ALERT = 'TOGGLE_ALERT';
export function toggleAlert(message, error) {
  return { message, error, type: TOGGLE_ALERT };
}

export const TOGGLE_MAP_LIST = 'TOGGLE_MAP_LIST';
export function toggleMapList() {
  return { type: TOGGLE_MAP_LIST };
}

export const SHOW_OVERLAY_FILTERS = 'SHOW_OVERLAY_FILTERS';
export function showOverlayFilters() {
  return ({ type: SHOW_OVERLAY_FILTERS });
}

export const HIDE_OVERLAY_FILTERS = 'HIDE_OVERLAY_FILTERS';
export function hideOverlayFilters() {
  return ({ type: HIDE_OVERLAY_FILTERS });
}

export const ENABLE_TRANSFER_RECORDS = 'ENABLE_TRANSFER_RECORDS';
export function enableTransferRecords() {
  return ({ type: ENABLE_TRANSFER_RECORDS });
}

export const DISABLE_TRANSFER_RECORDS = 'DISABLE_TRANSFER_RECORDS';
export function disableTransferRecords() {
  return ({ type: DISABLE_TRANSFER_RECORDS });
}
